<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="80"
        height="16"
        fill="none"
        viewBox="0 0 80 16"
        class="product-rating"
        :class="`product-rating--${rating} ${colors ? 'product-rating--colors' : ''}`"
    >
        <path fill="none" :stroke="stroke" stroke-width=".5" d="M8 1.93l1.96 4 4.37.64-3.16 3.1.75 4.4L8 12 4.1 14.07l.74-4.4-3.16-3.1 4.37-.64 1.96-4z"/>
        <path fill="none" :stroke="stroke" stroke-width=".5" d="M24 1.93l1.96 4 4.37.64-3.16 3.1.75 4.4L24 12l-3.91 2.07.74-4.4-3.16-3.1 4.37-.64 1.96-4z"/>
        <path fill="none" :stroke="stroke" stroke-width=".5" d="M40 1.93l1.96 4 4.37.64-3.16 3.1.75 4.4L40 12l-3.91 2.07.74-4.4-3.16-3.1 4.37-.64 1.96-4z"/>
        <path fill="none" :stroke="stroke" stroke-width=".5" d="M56 1.93l1.96 4 4.37.64-3.16 3.1.75 4.4L56 12l-3.91 2.07.74-4.4-3.16-3.1 4.37-.64 1.96-4z"/>
        <path fill="none" :stroke="stroke" stroke-width=".5" d="M72 1.93l1.96 4 4.37.64-3.16 3.1.75 4.4L72 12l-3.91 2.07.74-4.4-3.16-3.1 4.37-.64 1.96-4z"/>
    </svg>
</template>

<script>
const colors = ['#7C7E82', '#2F80ED', '#EB5757', '#9B51E0', '#C39B70'];

export default {
    name: 'rating-stars',

    props: {
        rating: {
            required: true,
            type: [String, Number],
        },

        colors: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        stroke() {
            if (!this.colors) return '#C39B70';

            return colors[+this.rating - 1];
        },
    },
};
</script>
